module.exports = __webpack_public_path__ + "static/allstarmoneyboxes-baebc554f20dffe66068ee1c4eb5e3ea.jpeg";